import { breakpoints } from '@/assets/data/breakpoints';

export const getSizes = ({ mobile = 100, tablet = 100, desktop = 100 }) => {
    return `(max-width: ${breakpoints.tablet}px) ${mobile}vw, (max-width: ${breakpoints.desktop}px) ${tablet}vw, ${desktop}vw`;
};
